<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper" >
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://www.edsv-seal.com/upload/${item.PICURL}`" alt="">
                <div class="text" :class="{'text2':index>0}">
              <div class="left" :class="{'noLeft':$i18n.locale==='en'}">
                  <p>{{item.ATEXT[0]}}</p>
                  <p>{{item.ATEXT[1]}}</p>
                  <p>{{item.ATEXT[2]}}</p>
              </div>
                    <div class="right">
                        <p>{{item.ATEXT[3]}}</p>
                        <p>{{item.ATEXT[4]}}</p>
                        <p>{{item.ATEXT[5]}}</p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="btn prev ">
            <i class="iconfont icon-xiangzuoyuanjiantouzuojiantouxiangzuoxianxing"></i>
        </div>
        <div class="btn next ">
            <i class="iconfont icon-xiangzuoyuanjiantouzuojiantouxiangzuoxianxing"></i>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getPicUrl} from '../util/lang'
    // import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            return{
                bList:[],
                swiperOptiona:{
                    loop: true,
                    effect: 'fade',
                    init: false,
                    navigation: {
                        prevEl: '.banner .btn.prev',
                        nextEl: '.banner .btn.next',
                    },
                    autoplay:{
                        disableOnInteraction: false,
                        delay: 5000
                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            this.getList()
        },
        methods:{
            aStyle(n){
                return {animationDelay:n*0.5+0.5+'s'}
            },
            getList(){
                const url = `${getPicUrl( 'zh-CN','首页banner',8)}`
                this.$axios.get(url).then(res => {
                    res.data.map((item)=>{
                        item.ATEXT=item.ATEXT.split('{nextpage}')
                    })
                    this.bList=res.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.banner{
    width:100%;
    height:100vh;
    position: relative;
    .swiper{
        height:100%;
        .item{
            position: relative;
            overflow: hidden;
            img{
                width:100%;
                height:100%;
                object-fit: cover;
                display: block;
                z-index: 1;
                cursor: pointer;
            }
            .text{
                z-index: 10;
                position: absolute;
                left: 10%;
                top:40%;
                display: flex;
                flex-direction: row;
                width:80%;
                 padding: 20px 0;
                height:180px;
                overflow: hidden;
       p{
           color:white;
           text-shadow: 2px 2px 6px rgba(0,0,0,.8);
       }
                .left{
                    transition: all 1s;
                    transform: translateX(-300px);
                    p{
                   font-family: "Microsoft YaHei";
                        font-size: 25px;
                        font-weight: bolder;
                        line-height: 50px;
                    }
                }
                .right{
                    margin-left: 10%;
                    transition: all 1s;
                    p{
                        font-family: os;
                        font-style: italic;
                    }
                    p:nth-child(1){
                        font-size: 35px;
                    }
                    p:nth-child(2),p:nth-child(3){
                        font-size: 25px;
                    }
                }
                .noLeft{
                    opacity: 0;
                }
                .right::before{
                    content:'';
                    display: inline-block;
                    height:1px;
                    width:0;
                    background-color: white;
                    position: absolute;
                    left:25%;
                    transition: all 2s;
                    top:1px;
                }
                .right::after{
                    content:'';
                    display: inline-block;
                    height:1px;
                    width:0;
                    background-color:#0071BD;
                    position: absolute;
                    left:0;
                    bottom:0;
                    z-index: 100;
                    transition: all 2s;
                }
            }
            .text::before{
                content:'';
                display: inline-block;
                height:1px;
                width:25%;
                background-color: #67B233;
                position: absolute;
                left:25%;
                top:1px;
            }
            .text::after{
                content:'';
                display: inline-block;
                height:1px;
                width:50%;
                background-color: #67B233;
                position: absolute;
                left:0;
                bottom:0;
            }
            .text2{
                .right::before{
                    display: none;
                }
                .right::after{
                    display: none;
                }
            }
            .text2::before{
                display: none !important;
            }
            .text2::after{
                display: none !important;
            }
        }
        .swiper-slide-active{
            .text{
                .left{
                    transform: translateX(0);
                }
                .right::after{
                    width:50%;
                }
                .right::before{
                    width:25%;
                }
            }
        }
    }
    .prev{
        position: absolute;
        bottom:50%;
        left:5%;
        padding:5px 5px;
        color:white;
        cursor: pointer;
        transform: rotate(180deg);
        transition: all 2s;
        z-index: 1000;
        i{
            font-size: 30px;
        }
    }
    .next{
        position: absolute;
        bottom:50%;
        right:5%;
        color:white;
        padding:5px 5px;
        cursor: pointer;
        transition: all 2s;
        z-index: 1000;
        i{
            font-size: 30px;
        }
    }
    .btn:hover{
        color:#005FAC;
    }
    .btn:focus{
        outline: none;
    }
    @media screen and (max-width: 999px){
        .swiper{
            .item{
                .text{
                    top:30%;
                    flex-direction: column;
                    height:300px;
                    .left,.right{
                        width:90%;
                        margin-left: 10%;
                    }
                    .left{
                        p{
                            font-size: 20px;
                            line-height: 40px;
                        }
                    }
                    .right{
                        margin-top: 30px;
                        p:nth-child(1){
                            font-size: 25px;
                        }
                        p:nth-child(2),p:nth-child(3){
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        .btn{
            -webkit-tap-highlight-color:rgba(255,255,255,0);
        }
    }
}
</style>
<style scoped>
    .banner .swiper-pagination {
        top: 55%;
        right:1.5%;
        width: 15%;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 60px;
        height:4px;
        border-radius: 20px;
        margin: 0 5px;
        background-color: transparent;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet::before{
        position: absolute;
        left:0;
        top:0;
        width:8px;
        height:8px;
        border-radius: 50%;
        background-color: white;
        content:'';
        display: inline-block;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height:8px;
        border-radius: 20px;
        background-color: #fff;
    }
    @media screen and (max-width:450px){
        .banner .swiper-pagination{
            width:40%;
        }
    }
</style>